/**
 * TextUtil.js
 * 
 * Created on 31-okt-2014, 9:54:31
 *
 * @author Harm Boschloo for Ranj
 * @author Ivo Swartjes for Ranj
 **/

import { isNull, isUndefined } from "../../util/TypeUtil";

export default class TextUtil {
    /**
     * Gets font size of a createjs.Text by parsing its font style
     * @param {createjs.Text} textField 
     * @returns {number} font size
     */
    static getFontSize(textField) {
        return TextUtil.getFontSizeFromStyle(textField.font);
    }

    /**
     * 
     * @param {string} fontStyle CSS font string
     * @returns {number} font size
     */
    static getFontSizeFromStyle(fontStyle) {
        return parseInt(TextUtil.REGEX_NUMBER.exec(fontStyle)[1]);
    }

    /**
     * Sets a new font size in the createjs.Text
     * 
     * @param {createjs.Text} textField 
     * @param {number} newSize 
     */
    static setFontSize(textField, newSize) {
        textField.font = TextUtil.setFontSizeInStyle(textField.font, newSize)
    }

    /**
     * Replaces the font size in a CSS font string with the given new size
     * @param {string} fontStyle CSS font string 
     * @param {number} newSize new font size
     * @returns {string} the CSS font with the new given size
     */
    static setFontSizeInStyle(fontStyle, newSize) {
        var newFont = fontStyle.replace(TextUtil.REGEX_NUMBER, newSize);
        return newFont;
    }


    /**
     * 
     * @param {createjs.Text} textField 
     * @returns {string} font name
     */
    static getFontName(textField) {
        return TextUtil.REGEX_FONT_NAME.exec(textField.font)[1];
    }

    /**
     * Centers text based on a original Y-coordinate and Height
     * 
     * @param {createjs.Text} textField 
     * @param {number} originalY 
     * @param {number} originalHeight 
     */
    static centerTextVertically(textField, originalY, originalHeight) {
        const height0 = originalHeight;
        const y0 = originalY;
        const height1 = textField.getMeasuredHeight();
        const y1 = y0 + (height0 - height1) / 2;
        textField.y = y1;
    }

    /**
     * 
     * @param {createjs.Text} textField 
     * @param {number} textFieldHeight 
     */
    static alignBottom(textField, textFieldHeight) {
        if (isUndefined(textField.y0)) {
            textField.y0 = textField.y;
        }
        var textHeight = textField.getMeasuredHeight();
        textField.y = textField.y0 + textFieldHeight - textHeight;
    }

    /**
     * Truncates the target createjs.Text into a single line
     * 
     * @param {createjs.Text} textField 
     * @param {String} truncateStr the replacing string to represent the truncated part
     * @param {Number?} maxWidth (optional) maximum width to truncate the text 
     * @returns 
     */
    static truncateSingleLine(textField, truncateStr = "…", maxWidth = null) {
        maxWidth = maxWidth || textField.lineWidth;
        // ignore operation if there is no given width
        if (isNull(maxWidth)) {
            return;
        }

        // NB: apply the CanvasRenderingContext2D to the TextField to determine size of text
        /** @type {CanvasRenderingContext2D} */
        const context = textField._prepContext(createjs.Text._workingContext);
        let line = textField.text;
        while (textField.getMetrics().lines.length > 1 || context.measureText(line).width > maxWidth) {
            line = line.substring(0, line.length - 1 - truncateStr.length) + truncateStr;
            textField.text = line;
        }
    }

}

TextUtil.REGEX_NUMBER = /^[^\d]*(\d+)/;
TextUtil.REGEX_FONT_NAME = /\'(.+)\'/;